import { Component, OnInit } from '@angular/core';
declare var $:any;


@Component({
  selector: 'app-sp-twothree-twofour',
  templateUrl: './sp-twothree-twofour.component.html',
  styleUrls: ['./sp-twothree-twofour.component.scss']
})
export class SpTwothreeTwofourComponent implements OnInit {
pdfSrc: string[] = [
  'https://drive.google.com/file/d/11lH3Em4wRPxxjefOZGTXxCOVXgBRADYG/preview', 
  'https://drive.google.com/file/d/1EIEhcmxXSeuP9nVvHMKLCOmnqoVFdAqR/preview',
  'https://drive.google.com/file/d/1iAKOK7YRzkOkUvCFa9sQ1ELp66FFME16/preview', 
  'https://drive.google.com/file/d/1Ln_sTkF8mhrFIPYGaGKALKSz5PtvYPpa/preview',
  'https://drive.google.com/file/d/1uyVpqOsAXTfVbVqj83MXXt_ad2qNjCCK/preview',
  'https://drive.google.com/file/d/1emdChiD7BVo0jj6fDlYv2fW1EmMCqfqb/preview',
  'https://drive.google.com/file/d/1eYUswsBVye-ZqJsxf9koKT9K7GG72DMz/preview',
  'https://drive.google.com/file/d/1N_6ymcZULV9u16mTjtEpRkWSr2CwMLo4/preview',
  'https://drive.google.com/file/d/1zacnqtcfRzR4uSJLGHTFIia0GEiMpPRe/preview',
  'https://drive.google.com/file/d/1Z68ahsf02k_ali38nWqo6hAAj8M_bH3M/preview',
  'https://drive.google.com/file/d/1j12CRCuEz2gaFBD8MqE52IfHTDMtKxl7/preview',
  'https://drive.google.com/file/d/15vJwOx-OA4cDcR-hFp5fI-S7GndoisQS/preview',
  'https://drive.google.com/file/d/1VrExTWBIl2ipCJJJ076eiyhB-JS_k1U5/preview',
  'https://drive.google.com/file/d/1pDf0vSip-4CfULJzrRxu_pXYzlbglYQa/preview',
  'https://drive.google.com/file/d/1iLbwBBZZASVbLGVvwHB_9uTBAX57ah8s/preview',
  'https://drive.google.com/file/d/19dZfOgawNyP5xcwkLahi8RtGTjLQWnWf/preview',
  'https://drive.google.com/file/d/1J1Lh5fHhulolw8ckhLnIU6h-FHM2tvtL/preview',
  'https://drive.google.com/file/d/1wqmD_w1DioIjoFstaqOq4Xq7uyfs89yg/preview',
  'https://drive.google.com/file/d/1IE4pIWyr2hwgPB95wvfiLrWRcXjdSB7T/preview'
];

src: string;
isLoading = true;

ngOnInit(): void { 
  this.changeRoute('1');
}

changeRoute(year: string) {
  this.isLoading = true;

  if (year == '1') {
    $('.first').addClass('active');
    $('.second').removeClass('active');
    $('.third').removeClass('active');
    $('.four').removeClass('active');
    $('.five').removeClass('active');
    $('.six').removeClass('active');
    $('.seven').removeClass('active');
    $('.eight').removeClass('active');
    $('.nine').removeClass('active');
    $('.ten').removeClass('active');
    $('.eleven').removeClass('active');
    $('.twelve').removeClass('active');
    $('.thirteen').removeClass('active');
    $('.fourteen').removeClass('active');
    $('.fifteen').removeClass('active');
    $('.sixteen').removeClass('active');
    $('.seventeen').removeClass('active');
    $('.eighteen').removeClass('active');
    $('.nineteen').removeClass('active');
    this.src = this.pdfSrc[0];
  }
  if (year == '2') {
    $('.second').addClass('active');
    $('.first').removeClass('active');
    $('.third').removeClass('active');
    $('.four').removeClass('active');
    $('.five').removeClass('active');
    $('.six').removeClass('active');
    $('.seven').removeClass('active');
    $('.eight').removeClass('active');
    $('.nine').removeClass('active');
    $('.ten').removeClass('active');
    $('.eleven').removeClass('active');
    $('.twelve').removeClass('active');
    $('.thirteen').removeClass('active');
    $('.fourteen').removeClass('active');
    $('.fifteen').removeClass('active');
    $('.sixteen').removeClass('active');
    $('.seventeen').removeClass('active');
    $('.eighteen').removeClass('active');
    $('.nineteen').removeClass('active');
    this.src = this.pdfSrc[1];
  }
  if (year == '3') {
    $('.third').addClass('active');
    $('.first').removeClass('active');
    $('.second').removeClass('active');
    $('.four').removeClass('active');
    $('.five').removeClass('active');
    $('.six').removeClass('active');
    $('.seven').removeClass('active');
    $('.eight').removeClass('active');
    $('.nine').removeClass('active');
    $('.ten').removeClass('active');
    $('.eleven').removeClass('active');
    $('.twelve').removeClass('active');
    $('.thirteen').removeClass('active');
    $('.fourteen').removeClass('active');
    $('.fifteen').removeClass('active');
    $('.sixteen').removeClass('active');
    $('.seventeen').removeClass('active');
    $('.eighteen').removeClass('active');
    $('.nineteen').removeClass('active');
    this.src = this.pdfSrc[2];
  }
  if (year == '4') {
    $('.four').addClass('active');
    $('.first').removeClass('active');
    $('.third').removeClass('active');
    $('.second').removeClass('active');
    $('.five').removeClass('active');
    $('.six').removeClass('active');
    $('.seven').removeClass('active');
    $('.eight').removeClass('active');
    $('.nine').removeClass('active');
    $('.ten').removeClass('active');
    $('.eleven').removeClass('active');
    $('.twelve').removeClass('active');
    $('.thirteen').removeClass('active');
    $('.fourteen').removeClass('active');
    $('.fifteen').removeClass('active');
    $('.sixteen').removeClass('active');
    $('.seventeen').removeClass('active');
    $('.eighteen').removeClass('active');
    $('.nineteen').removeClass('active');
    this.src = this.pdfSrc[3];
  }
  if (year == '5') {
    $('.five').addClass('active');
    $('.first').removeClass('active');
    $('.third').removeClass('active');
    $('.second').removeClass('active');
    $('.four').removeClass('active');
    $('.six').removeClass('active');
    $('.seven').removeClass('active');
    $('.eight').removeClass('active');
    $('.nine').removeClass('active');
    $('.ten').removeClass('active');
    $('.eleven').removeClass('active');
    $('.twelve').removeClass('active');
    $('.thirteen').removeClass('active');
    $('.fourteen').removeClass('active');
    $('.fifteen').removeClass('active');
    $('.sixteen').removeClass('active');
    $('.seventeen').removeClass('active');
    $('.eighteen').removeClass('active');
    $('.nineteen').removeClass('active');
    this.src = this.pdfSrc[4];
  }
  if (year == '6') {
    $('.six').addClass('active');
    $('.first').removeClass('active');
    $('.third').removeClass('active');
    $('.second').removeClass('active');
    $('.five').removeClass('active');
    $('.four').removeClass('active');
    $('.seven').removeClass('active');
    $('.eight').removeClass('active');
    $('.nine').removeClass('active');
    $('.ten').removeClass('active');
    $('.eleven').removeClass('active');
    $('.twelve').removeClass('active');
    $('.thirteen').removeClass('active');
    $('.fourteen').removeClass('active');
    $('.fifteen').removeClass('active');
    $('.sixteen').removeClass('active');
    $('.seventeen').removeClass('active');
    $('.eighteen').removeClass('active');
    $('.nineteen').removeClass('active');
    this.src = this.pdfSrc[5];
  }
  if (year == '7') {
    $('.seven').addClass('active');
    $('.first').removeClass('active');
    $('.third').removeClass('active');
    $('.second').removeClass('active');
    $('.five').removeClass('active');
    $('.six').removeClass('active');
    $('.four').removeClass('active');
    $('.eight').removeClass('active');
    $('.nine').removeClass('active');
    $('.ten').removeClass('active');
    $('.eleven').removeClass('active');
    $('.twelve').removeClass('active');
    $('.thirteen').removeClass('active');
    $('.fourteen').removeClass('active');
    $('.fifteen').removeClass('active');
    $('.sixteen').removeClass('active');
    $('.seventeen').removeClass('active');
    $('.eighteen').removeClass('active');
    $('.nineteen').removeClass('active');
    this.src = this.pdfSrc[6];
  }
  if (year == '8') {
    $('.eight').addClass('active');
    $('.first').removeClass('active');
    $('.third').removeClass('active');
    $('.second').removeClass('active');
    $('.five').removeClass('active');
    $('.six').removeClass('active');
    $('.seven').removeClass('active');
    $('.four').removeClass('active');
    $('.nine').removeClass('active');
    $('.ten').removeClass('active');
    $('.eleven').removeClass('active');
    $('.twelve').removeClass('active');
    $('.thirteen').removeClass('active');
    $('.fourteen').removeClass('active');
    $('.fifteen').removeClass('active');
    $('.sixteen').removeClass('active');
    $('.seventeen').removeClass('active');
    $('.eighteen').removeClass('active');
    $('.nineteen').removeClass('active');
    this.src = this.pdfSrc[7];
  }
  if (year == '9') {
    $('.nine').addClass('active');
    $('.first').removeClass('active');
    $('.third').removeClass('active');
    $('.second').removeClass('active');
    $('.five').removeClass('active');
    $('.six').removeClass('active');
    $('.seven').removeClass('active');
    $('.eight').removeClass('active');
    $('.four').removeClass('active');
    $('.ten').removeClass('active');
    $('.eleven').removeClass('active');
    $('.twelve').removeClass('active');
    $('.thirteen').removeClass('active');
    $('.fourteen').removeClass('active');
    $('.fifteen').removeClass('active');
    $('.sixteen').removeClass('active');
    $('.seventeen').removeClass('active');
    $('.eighteen').removeClass('active');
    $('.nineteen').removeClass('active');
    this.src = this.pdfSrc[8];
  }
  if (year == '10') {
    $('.ten').addClass('active');
    $('.first').removeClass('active');
    $('.third').removeClass('active');
    $('.second').removeClass('active');
    $('.five').removeClass('active');
    $('.six').removeClass('active');
    $('.seven').removeClass('active');
    $('.eight').removeClass('active');
    $('.nine').removeClass('active');
    $('.four').removeClass('active');
    $('.eleven').removeClass('active');
    $('.twelve').removeClass('active');
    $('.thirteen').removeClass('active');
    $('.fourteen').removeClass('active');
    $('.fifteen').removeClass('active');
    $('.sixteen').removeClass('active');
    $('.seventeen').removeClass('active');
    $('.eighteen').removeClass('active');
    $('.nineteen').removeClass('active');
    this.src = this.pdfSrc[9];
  }
  if (year == '11') {
    $('.eleven').addClass('active');
    $('.first').removeClass('active');
    $('.third').removeClass('active');
    $('.second').removeClass('active');
    $('.five').removeClass('active');
    $('.six').removeClass('active');
    $('.seven').removeClass('active');
    $('.eight').removeClass('active');
    $('.nine').removeClass('active');
    $('.ten').removeClass('active');
    $('.four').removeClass('active');
    $('.twelve').removeClass('active');
    $('.thirteen').removeClass('active');
    $('.fourteen').removeClass('active');
    $('.fifteen').removeClass('active');
    $('.sixteen').removeClass('active');
    $('.seventeen').removeClass('active');
    $('.eighteen').removeClass('active');
    $('.nineteen').removeClass('active');
    this.src = this.pdfSrc[10];
  }
  if (year == '12') {
    $('.twelve').addClass('active');
    $('.first').removeClass('active');
    $('.third').removeClass('active');
    $('.second').removeClass('active');
    $('.five').removeClass('active');
    $('.six').removeClass('active');
    $('.seven').removeClass('active');
    $('.eight').removeClass('active');
    $('.nine').removeClass('active');
    $('.ten').removeClass('active');
    $('.eleven').removeClass('active');
    $('.four').removeClass('active');
    $('.thirteen').removeClass('active');
    $('.fourteen').removeClass('active');
    $('.fifteen').removeClass('active');
    $('.sixteen').removeClass('active');
    $('.seventeen').removeClass('active');
    $('.eighteen').removeClass('active');
    $('.nineteen').removeClass('active');
    this.src = this.pdfSrc[11];
  }
  if (year == '13') {
    $('.thirteen').addClass('active');
    $('.first').removeClass('active');
    $('.third').removeClass('active');
    $('.second').removeClass('active');
    $('.five').removeClass('active');
    $('.six').removeClass('active');
    $('.seven').removeClass('active');
    $('.eight').removeClass('active');
    $('.nine').removeClass('active');
    $('.ten').removeClass('active');
    $('.eleven').removeClass('active');
    $('.twelve').removeClass('active');
    $('.four').removeClass('active');
    $('.fourteen').removeClass('active');
    $('.fifteen').removeClass('active');
    $('.sixteen').removeClass('active');
    $('.seventeen').removeClass('active');
    $('.eighteen').removeClass('active');
    $('.nineteen').removeClass('active');
    this.src = this.pdfSrc[12];
  }
  if (year == '14') {
    $('.fourteen').addClass('active');
    $('.first').removeClass('active');
    $('.third').removeClass('active');
    $('.second').removeClass('active');
    $('.five').removeClass('active');
    $('.six').removeClass('active');
    $('.seven').removeClass('active');
    $('.eight').removeClass('active');
    $('.nine').removeClass('active');
    $('.ten').removeClass('active');
    $('.eleven').removeClass('active');
    $('.twelve').removeClass('active');
    $('.thirteen').removeClass('active');
    $('.four').removeClass('active');
    $('.fifteen').removeClass('active');
    $('.sixteen').removeClass('active');
    $('.seventeen').removeClass('active');
    $('.eighteen').removeClass('active');
    $('.nineteen').removeClass('active');
    this.src = this.pdfSrc[13];
  }
  if (year == '15') {
    $('.fifteen').addClass('active');
    $('.first').removeClass('active');
    $('.third').removeClass('active');
    $('.second').removeClass('active');
    $('.five').removeClass('active');
    $('.six').removeClass('active');
    $('.seven').removeClass('active');
    $('.eight').removeClass('active');
    $('.nine').removeClass('active');
    $('.ten').removeClass('active');
    $('.eleven').removeClass('active');
    $('.twelve').removeClass('active');
    $('.thirteen').removeClass('active');
    $('.four').removeClass('active');
    $('.fourteen').removeClass('active');
    $('.sixteen').removeClass('active');
    $('.seventeen').removeClass('active');
    $('.eighteen').removeClass('active');
    $('.nineteen').removeClass('active');
    this.src = this.pdfSrc[14];
  }
  if (year == '16') {
    $('.sixteen').addClass('active');
    $('.first').removeClass('active');
    $('.third').removeClass('active');
    $('.second').removeClass('active');
    $('.five').removeClass('active');
    $('.six').removeClass('active');
    $('.seven').removeClass('active');
    $('.eight').removeClass('active');
    $('.nine').removeClass('active');
    $('.ten').removeClass('active');
    $('.eleven').removeClass('active');
    $('.twelve').removeClass('active');
    $('.thirteen').removeClass('active');
    $('.four').removeClass('active');
    $('.fifteen').removeClass('active');
    $('.fourteen').removeClass('active');
    $('.seventeen').removeClass('active');
    $('.eighteen').removeClass('active');
    $('.nineteen').removeClass('active');
    this.src = this.pdfSrc[15];
  }
  if (year == '17') {
    $('.seventeen').addClass('active');
    $('.first').removeClass('active');
    $('.third').removeClass('active');
    $('.second').removeClass('active');
    $('.five').removeClass('active');
    $('.six').removeClass('active');
    $('.seven').removeClass('active');
    $('.eight').removeClass('active');
    $('.nine').removeClass('active');
    $('.ten').removeClass('active');
    $('.eleven').removeClass('active');
    $('.twelve').removeClass('active');
    $('.thirteen').removeClass('active');
    $('.four').removeClass('active');
    $('.fifteen').removeClass('active');
    $('.sixteen').removeClass('active');
    $('.fourteen').removeClass('active');
    $('.eighteen').removeClass('active');
    $('.nineteen').removeClass('active');
    this.src = this.pdfSrc[16];
  }
  if (year == '18') {
    $('.eighteen').addClass('active');
    $('.first').removeClass('active');
    $('.third').removeClass('active');
    $('.second').removeClass('active');
    $('.five').removeClass('active');
    $('.six').removeClass('active');
    $('.seven').removeClass('active');
    $('.eight').removeClass('active');
    $('.nine').removeClass('active');
    $('.ten').removeClass('active');
    $('.eleven').removeClass('active');
    $('.twelve').removeClass('active');
    $('.thirteen').removeClass('active');
    $('.four').removeClass('active');
    $('.fifteen').removeClass('active');
    $('.sixteen').removeClass('active');
    $('.seventeen').removeClass('active');
    $('.fourteen').removeClass('active');
    $('.nineteen').removeClass('active');
    this.src = this.pdfSrc[17];
  }
  if (year == '19') {
    $('.nineteen').addClass('active');
    $('.first').removeClass('active');
    $('.third').removeClass('active');
    $('.second').removeClass('active');
    $('.five').removeClass('active');
    $('.six').removeClass('active');
    $('.seven').removeClass('active');
    $('.eight').removeClass('active');
    $('.nine').removeClass('active');
    $('.ten').removeClass('active');
    $('.eleven').removeClass('active');
    $('.twelve').removeClass('active');
    $('.thirteen').removeClass('active');
    $('.four').removeClass('active');
    $('.fifteen').removeClass('active');
    $('.sixteen').removeClass('active');
    $('.seventeen').removeClass('active');
    $('.eighteen').removeClass('active');
    $('.fourteen').removeClass('active');
    this.src = this.pdfSrc[18];
  }
}
hideLoader() {
    this.isLoading = false;
  }
}
